import coursepoolImage1 from '../../assets/projects/coursepool/01_homepage.png';
import tournionImage1 from '../../assets/projects/tournion/1.png';
import askOverflowImage1 from '../../assets/projects/askoverflow/1.png';
import portfolioImage1 from '../../assets/projects/portfolio/1.png';

export const allProjects = [
    {
        title: 'CoursePool',
        githubLink: 'https://github.com/dharmesh-poriya/CoursePool',
        liveLink: 'https://www.coursepool.tech/',
        tools: ['NextJS', 'TypeScript', 'NodeJS', 'ExpressJS', 'Tailwind CSS', 'SocketIo', 'MongoDB', 'RTKQuery', 'Redis cache'],
        description: `My friend and I collaborated on the development of this project, a learning platform designed for users to purchase courses and enhance their skills. Users can authenticate using Google or GitHub credentials. The admin privileges include course management functionalities such as creation, modification, and deletion. Additionally, we incorporated charts visualization for administrative purposes and integrated a payment gateway for seamless course purchases. To optimize network speed, we implemented RTK query and utilized Redis cache.`,
        Image: coursepoolImage1,
        status: 'Completed'
    },
    {
        title: 'TourNion',
        githubLink: 'https://github.com/dharmesh-poriya/TourNion',
        liveLink: 'https://tournion.netlify.app/',
        tools: ['React', 'Node JS', 'Express JS', 'MongoDB', 'ReduxToolkit'],
        description: `My friend and I developed this project, a platform dedicated to sharing tour opinions. It serves as a valuable resource for individuals seeking information about various destinations before their visit. Users can explore detailed insights about specific tours and share their own experiences by creating posts. This platform facilitates an exchange of valuable information among users, helping them make informed decisions about their travel plans.`,
        Image: tournionImage1,
        status: 'Completed'
    },
    {
        title: 'AskOverflow',
        githubLink: 'https://github.com/dharmesh-poriya/askoverflow-client',
        liveLink: 'https://askoverflow.netlify.app/',
        tools: ['React', 'Node JS', 'Express JS', 'MongoDB'],
        description: `My friend and I collaborated on this project, creating a question and answer platform tailored for both professional programmers and enthusiasts. As part of the Stack Overflow community, we developed and maintain this site with the collective goal of compiling comprehensive answers to programming queries. This project serves as a clone of Stack Overflow.`,
        Image: askOverflowImage1,
        status: 'Completed'
    },
    {
        title: 'Portfolio',
        githubLink: 'https://github.com/dharmesh-poriya/dharmesh-poriya',
        liveLink: 'https://dharmesh-poriya.netlify.app/',
        tools: ['React', 'Bootstrap'],
        description: `This portfolio was developed using React and Bootstrap, resulting in a single-page application. It boasts responsiveness and was crafted solely by me, serving as a comprehensive digital resume.`,
        Image: portfolioImage1,
        status: 'Completed'
    },
]
